import css from 'styled-jsx/css';

const styles = css.global`#modal-apartment {
  z-index: 9999;
  overflow-y: visible;
}

#modal-apartment.enabled-scroll {
  overflow-y: auto;
  align-items: flex-start;
  padding: 8px 0;
}

#modal-apartment .modal-content {
  max-height: 650px;
  max-width: 288px;
}

.modal-apartment {
  background: #ffffff;
  border: 1px solid #c7c7c7;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 32px 8px;
  margin: 0;
  box-sizing: border-box;
}

.modal-apartment .logo {
  max-width: 186px;
  width: 100%;
  height: auto;
  object-fit: contain;
  display: flex;
  margin: 0 auto;
}

.modal-apartment .title {
  font-family: 'SantanderText';
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #222;
  max-width: 272px;
  margin: 16px auto;
}

.modal-apartment .description {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #222;
  max-width: 288px;
  margin: 0 auto 24px;
}

.modal-apartment .description b {
  font-weight: 600;
}

.modal-apartment .sn-button {
  max-width: 256px;
  margin: 0 auto;
}

.modal-apartment .sn-button.red {
  margin-bottom: 24px;
}

@media (min-width: 992px) {
  .modal-apartment .title,
  .modal-apartment .description {
    max-width: 420px;
  }

  #modal-apartment .modal-content {
    max-width: 472px;
  }

  .modal-apartment {
    margin: 0;
    padding: 32px 16px;
  }

  .modal-apartment .logo {
    max-width: 240px;
  }

  .modal-apartment .sn-button {
    max-width: 100%;
  }
}
`;

export default styles;